import { useSearchParams } from "react-router-dom";
import { MessageCircle, Phone } from "lucide-react";
import { SITE, waLink, telLink } from "../data/siteConfig";
import { useSEO } from "../components/SEO";
import FadeIn from "../components/FadeIn";
import EnquiryForm from "../components/EnquiryForm";

const BookTestPage = () => {
  useSEO(
    "Book a Test in Bhopal | Dr Lal PathLabs Collection Center",
    "Book a diagnostic test at Dr Lal PathLabs Collection Center Bhopal. Submit your enquiry and our team will confirm your appointment. Call 8959830932."
  );
  const [params] = useSearchParams();
  const defaultTest = params.get("test") || "";
  const defaultPreference = params.get("type") === "home" ? "Home Sample Collection" : "Collection Center Visit";

  return (
    <div>
      <section className="bg-[#0B3056] py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <FadeIn>
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-blue-200">Easy Booking</p>
            <h1 className="font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl">Book a Diagnostic Test</h1>
            <p className="mt-4 max-w-2xl text-base text-blue-100 md:text-lg">
              Submit your enquiry and our collection center team will contact you to confirm the details.
            </p>
          </FadeIn>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-3">
          <FadeIn className="lg:col-span-2">
            <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm sm:p-8">
              <EnquiryForm
                mode="booking"
                enquiryType="booking"
                defaultTest={defaultTest}
                defaultPreference={defaultPreference}
                testIdPrefix="booking"
              />
            </div>
          </FadeIn>

          <FadeIn delay={0.1}>
            <aside className="space-y-5">
              <div className="rounded-2xl border border-gray-100 bg-[#F0F7FA] p-7">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white">
                  <MessageCircle size={22} aria-hidden="true" />
                </span>
                <h2 className="mt-4 font-heading text-lg font-bold text-[#0B3056]">Prefer WhatsApp?</h2>
                <p className="mt-2 text-sm text-slate-600">
                  Send us your test requirement and our team can assist with your enquiry.
                </p>
                <a
                  href={waLink("Hello, I would like to enquire about a diagnostic test at Dr Lal PathLabs Collection Center, Bhopal.")}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="booking-whatsapp-button"
                  className="mt-5 inline-flex min-h-[44px] w-full items-center justify-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#1eb856]"
                >
                  <MessageCircle size={17} aria-hidden="true" /> Chat on WhatsApp
                </a>
              </div>

              <div className="rounded-2xl border border-gray-100 bg-white p-7 shadow-sm">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#F0F7FA] text-[#1E88E5]">
                  <Phone size={22} aria-hidden="true" />
                </span>
                <h2 className="mt-4 font-heading text-lg font-bold text-[#0B3056]">Call the Center</h2>
                <p className="mt-2 text-sm text-slate-600">Speak directly with our collection center team.</p>
                <a
                  href={telLink}
                  data-testid="booking-call-button"
                  className="mt-5 inline-flex min-h-[44px] w-full items-center justify-center gap-2 rounded-full border-2 border-[#1E88E5] px-6 py-3 text-sm font-semibold text-[#1E88E5] transition-colors hover:bg-[#F0F7FA]"
                >
                  <Phone size={17} aria-hidden="true" /> {SITE.phone}
                </a>
              </div>
            </aside>
          </FadeIn>
        </div>
      </section>
    </div>
  );
};

export default BookTestPage;
